module.exports = __webpack_public_path__ + "media/images/promotions/cards/chance-1000-aac9a20c6a223f6ff46bc4802074f1f5.svg";